module.exports = __webpack_public_path__ + "static/media/home-mobilePaymentsLogos.e1843cbe.png";